import { Action } from '@ngrx/store';

export enum UiActionsTypes {
  TOGGLE_TERMINAL = '[Ui] Toggle terminal',
}

export class ToggleTerminal implements Action {
  readonly type = UiActionsTypes.TOGGLE_TERMINAL;
  constructor(public payload: { isOpen: boolean }) {}
}

export type UiActions = ToggleTerminal;
